<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title67"></a>
<div class="p-c"><span><em class="i">For Amy</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429939874_ded01.vue?3c7da25c